import { render, staticRenderFns } from "./TokenImportForm.vue?vue&type=template&id=71591492&scoped=true&"
import script from "./TokenImportForm.vue?vue&type=script&lang=js&"
export * from "./TokenImportForm.vue?vue&type=script&lang=js&"
import style0 from "./TokenImportForm.vue?vue&type=style&index=0&id=71591492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71591492",
  null
  
)

export default component.exports